"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultMessage = exports.FieldContainer = exports.ErrorMessage = exports.SuccessMessage = exports.JsonDisplay = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const apiUtils_1 = require("../../../../util/apiUtils");
const theme_1 = require("../../../../theme");
const common_styled_components_1 = require("../../../common-styled-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.JsonDisplay = styled_components_1.default.pre `
  background-color: ${theme_1.theme.colors.grey(5)};
  padding: ${theme_1.theme.spacing(2)};
  border-radius: 4px;
  overflow: auto;
  max-height: 500px;
  font-size: 12px;
  border: 1px solid ${theme_1.theme.colors.grey(3)};
`;
exports.SuccessMessage = styled_components_1.default.div `
  color: ${theme_1.theme.colors.green};
  padding: ${theme_1.theme.spacing(2)};
  background-color: ${theme_1.theme.colors.grey(5)};
  border-radius: 4px;
  border: 1px solid ${theme_1.theme.colors.green};
`;
exports.ErrorMessage = styled_components_1.default.div `
  color: ${theme_1.theme.colors.red};
  padding: ${theme_1.theme.spacing(2)};
  background-color: ${theme_1.theme.colors.grey(5)};
  border-radius: 4px;
  border: 1px solid ${theme_1.theme.colors.red};
`;
const FieldContainer = ({ label, children, }) => ((0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { style: { maxWidth: 400 }, children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: label }), children] }));
exports.FieldContainer = FieldContainer;
const ResultMessage = ({ response, mode, statsRenderer, }) => {
    if (response.status !== apiUtils_1.LoaderStatus.Success)
        return null;
    const data = response.data;
    const isIntegration = mode === "integration";
    if (isIntegration && data?.status === "ok") {
        return ((0, jsx_runtime_1.jsxs)(exports.SuccessMessage, { children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("strong", { children: "Success!" }) }), (0, jsx_runtime_1.jsx)("div", { children: data.message }), data.voyages_count !== undefined && ((0, jsx_runtime_1.jsxs)("div", { children: ["Voyages stored: ", data.voyages_count] })), statsRenderer && statsRenderer(data), data.error_count !== undefined && data.error_count > 0 && ((0, jsx_runtime_1.jsxs)("div", { style: { color: theme_1.theme.colors.red }, children: ["Errors: ", data.error_count] }))] }));
    }
    if (isIntegration && data?.status === "error") {
        return ((0, jsx_runtime_1.jsxs)(exports.ErrorMessage, { children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("strong", { children: "Error!" }) }), (0, jsx_runtime_1.jsx)("div", { children: data.message }), statsRenderer && statsRenderer(data), data.error_count !== undefined && ((0, jsx_runtime_1.jsxs)("div", { children: ["Errors: ", data.error_count] })), data.errors && data.errors.length > 0 && ((0, jsx_runtime_1.jsxs)("div", { style: { marginTop: theme_1.theme.spacing(1) }, children: [(0, jsx_runtime_1.jsx)("strong", { children: "Detailed Errors:" }), (0, jsx_runtime_1.jsx)("ul", { style: {
                                paddingLeft: theme_1.theme.spacing(2),
                                marginTop: theme_1.theme.spacing(0.5),
                            }, children: data.errors.map((err, idx) => ((0, jsx_runtime_1.jsxs)("li", { children: ["Ship ", err.ship_imo, ", ", err.endpoint ?? err.dataset, ":", " ", err.error] }, idx))) })] }))] }));
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: "API Response:" }), (0, jsx_runtime_1.jsx)(exports.JsonDisplay, { children: JSON.stringify(data, null, 2) })] }));
};
exports.ResultMessage = ResultMessage;
